import React from 'react';
import { useAdmin } from '../contexts/AdminContext';
import './AdminGear.css';

const AdminGear = () => {
  const {
    isAdmin,
    showAdminModal,
    adminCodeInput,
    setAdminCodeInput,
    verifyAdminCode,
    logoutAdmin,
    toggleAdminModal,
    setShowAdminModal,
  } = useAdmin();

  const handleVerify = () => {
    if (verifyAdminCode(adminCodeInput)) {
      alert('✅ Admin mode activated!');
    } else {
      alert('❌ Invalid code');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleVerify();
    }
  };

  return (
    <>
      {/* Floating Gear Button */}
      <button 
        className={`admin-gear-button ${isAdmin ? 'admin-active' : ''}`}
        onClick={toggleAdminModal}
        title={isAdmin ? 'Admin Mode Active' : 'Admin Settings'}
      >
        ⚙️
      </button>

      {/* Admin Modal */}
      {showAdminModal && (
        <div className="admin-modal-overlay" onClick={() => setShowAdminModal(false)}>
          <div className="admin-modal" onClick={e => e.stopPropagation()}>
            <button className="admin-modal-close" onClick={() => setShowAdminModal(false)}>×</button>
            
            {!isAdmin ? (
              <>
                <h3>🔐 Admin Access</h3>
                <p>Enter admin code to enable admin features:</p>
                <input
                  type="password"
                  value={adminCodeInput}
                  onChange={(e) => setAdminCodeInput(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Enter admin code..."
                  autoFocus
                />
                <div className="admin-modal-buttons">
                  <button onClick={handleVerify}>Verify</button>
                </div>
              </>
            ) : (
              <>
                <h3>🛠️ Admin Mode Active</h3>
                <p>You have admin privileges enabled.</p>
                <div className="admin-status">
                  <span className="admin-badge">✓ ADMIN</span>
                </div>
                <div className="admin-modal-buttons">
                  <button onClick={logoutAdmin} className="logout-btn">
                    Exit Admin Mode
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AdminGear;
